import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserState, userStateFeatureKey } from "./reducer";

export const selectUserState =
    createFeatureSelector<UserState>(userStateFeatureKey);

export const selectUserName = createSelector(
    selectUserState,
    (state) => state.username,
);

export const selectIdTokenClaims = createSelector(
    selectUserState,
    (state) => state.idTokenClaims,
);
